export default function Hero() {
  const chips = [
    "塌房瞬间",
    "人设崩塌",
    "滤镜破碎",
    "偶像失格",
    "人设翻车",
    "同款回旋镖",
    "年度名场面",
  ];

  return (
    <section
      id="top"
      className="relative overflow-hidden bg-foreground-950 text-background-50"
    >
      {/* 装饰层 */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-90"
        style={{
          backgroundImage:
            "radial-gradient(circle at 12% 18%, oklch(var(--primary-500)/0.5), transparent 34%), radial-gradient(circle at 88% 12%, oklch(var(--accent-500)/0.35), transparent 30%), radial-gradient(circle at 78% 85%, oklch(var(--primary-800)/0.4), transparent 36%)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 top-8 select-none font-heading text-[26rem] font-black leading-none text-background-50/[0.04] md:right-10"
      >
        瓜
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col px-4 pb-16 pt-28 md:px-6 md:pt-36 lg:pb-24">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-accent-400">
          <span className="inline-block h-px w-8 bg-accent-500" />
          反差档案 · 持续更新
        </p>

        <h1 className="mt-6 max-w-5xl font-heading text-4xl font-black leading-[1.12] tracking-tightest text-background-50 sm:text-5xl md:text-6xl lg:text-7xl">
          同一副面孔，
          <br />
          到底有几版<span className="text-primary-400">「反差」</span>？
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-200/90 md:text-lg">
          吃瓜反差把「立人设期」与「翻车后」的公开言行、精修物料与同场生图逐帧并排。
          塌房瞬间、人设崩塌、滤镜破碎、偶像失格——崩得碎不碎，摆在一起一目了然。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#week"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            刷本周名场面
            <i className="ri-arrow-down-line" />
          </a>
          <a
            href="#contrast"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/30 bg-background-50/5 px-6 py-3 text-sm font-semibold text-background-100 transition-colors hover:bg-background-50/15"
          >
            <i className="ri-swap-2-fill text-accent-400" />
            看反差对照
          </a>
        </div>

        {/* 关键词条 */}
        <div className="mt-12 flex flex-wrap items-center gap-2">
          {chips.map((c) => (
            <span
              key={c}
              className="flex items-center gap-1 rounded-full border border-background-200/20 bg-background-50/5 px-3 py-1.5 text-xs font-medium text-background-200"
            >
              <i className="ri-flashlight-fill text-accent-500" />
              {c}
            </span>
          ))}
        </div>
      </div>

      {/* 底部条带 */}
      <div className="relative border-t border-background-50/10">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-8 gap-y-2 px-4 py-4 text-xs text-background-300/80 md:px-6">
          <span className="flex items-center gap-2">
            <i className="ri-verified-badge-fill text-primary-400" />
            仅整理公开可查证物料 · 不信谣不传谣
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-time-line text-accent-500" />
            热门档案每 24 小时滚动刷新
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-focus-3-fill text-secondary-400" />
            逐帧显微镜 · 客观围观
          </span>
        </div>
      </div>
    </section>
  );
}